/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/betting-cancel.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'
import useRootStore from '@store/useRootStore'
import dayjs from 'dayjs'
import * as Utils from '@utils/utils'
import * as _ from 'lodash'

export const UnableToJoinInfo: React.FC = observer(() => {
  const { globalStore } = useRootStore()
  const accountTransferOpt = globalStore.getAccountTransferOptions()
  const fromDate = accountTransferOpt?.period?.from

  let fromDateText = ''
  if (!_.isEmpty(fromDate)) {
    const dateInst = dayjs(fromDate)
    if (dateInst.isValid()) {
      const [month, day] = [dateInst.month() + 1, dateInst.date()]
      const dayOfWeek = Utils.getDayOfWeeks(fromDate)
      fromDateText = `${month}/${day}(${dayOfWeek})`
    }
  }

  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      카카오 신규가입 불가
    </p>
  )
const body = (
    <div className="guide-box small ">
      승부사온라인 카카오 신규 가입 서비스가<br/>
      <span className="point-color--orange--modal">{`${fromDateText}부로 종료`}</span>되었습니다.<br/>
      다른 방법으로 회원가입해 주시기 바랍니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
